import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@app/../environments/environment';
import {Observable} from 'rxjs';
import {map, publishReplay, refCount} from 'rxjs/operators';
import {Esg} from '@app/dto/Esg';

@Injectable({
  providedIn: 'root'
})
export class AdminEsgService {
  private cache$: Observable<Esg>[] = [];

  constructor(private http: HttpClient) {
  }

  public get(id: number, useCache: boolean = false): Observable<Esg> {
    if (!this.cache$[id] || !useCache) {
      this.cache$[id] = this.http
        .get<Esg>(`${environment.serverUrl}esgs/get-esg/${id}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        );
    }

    return this.cache$[id];
  }

  public create(model: Esg): Observable<Esg> {
    return this.http.post<Esg>(`${environment.serverUrl}esgs/add-esg`, model);
  }

  public update(model: Esg): Observable<Esg> {
    return this.http.put<Esg>(`${environment.serverUrl}esgs/edit-esg`, model);
  }


  clearCache(id: number | null = null) {
    if (this.cache$ && id) {
      this.cache$[id] = null;
    } else {
      this.cache$ = null;
    }
  }


}
